import { useLoader } from '@react-three/fiber';
import { TextureLoader } from 'three';

import conversionCreditNormal from './assets/conversion-credit-normal.svg';
import conversionCreditRoughness from './assets/conversion-credit-roughness.svg';
import conversionCreditSideNormal from './assets/conversion-credit-side-normal.svg';
import conversionCreditSide from './assets/conversion-credit-side.svg';
import conversionCredit from './assets/conversion-credit.svg';

export const ConversionCreditPreloader = () => {
  useLoader(TextureLoader, [
    conversionCredit,
    conversionCreditNormal,
    conversionCreditRoughness,
    conversionCreditSide,
    conversionCreditSideNormal,
  ]);
  return null;
};

export default ConversionCreditPreloader;
